import { Link } from "react-router-dom";

// Urls
import { RedirectTo } from "../../urls/PageLinksURL";

// Constants and Utils
import { checkIsSellerUser } from "../../utils/SellerUtils";
import { constructRedirectPath } from "../../utils/redirect-utils/RedirectUtils";
import {
  LocalStorageKeys,
  OrganizationIdsMapping,
  UrlKeys,
} from "../../constants/GeneralConstants";
import { useUrlKeyCheck } from "../../mavin/utils/hooks/HooksUtil";
import { getItem } from "../../utils/localstorage";
import { checkIsOrgSpecific } from "../../utils/OrgUtils";

// Page Constants
const {
  helpOtsPageUrl,
  helpLtsPageUrl,
  helpCovidChangePageUrl,
  helpDefinitionPageUrl,
  helpVideosPageUrl,
} = RedirectTo;

function MethodologiesSection({ activePageUrl, isToohlSpecific }) {
  // Checking the USER is Seller or not
  const isSellerUser = checkIsSellerUser();

  // coral media
  const user = JSON.parse(getItem(LocalStorageKeys.USER));
  const { orgId } = user || {};
  const { coralMedia } = OrganizationIdsMapping;
  const isCoralMediaSpecific = checkIsOrgSpecific(orgId, coralMedia);

  // constants
  const sidebarMethodologiesConstants = [
    {
      label: "OTS",
      pageUrl: helpOtsPageUrl,
      isShow: true,
    },
    {
      label: "LTS",
      pageUrl: helpLtsPageUrl,
      isShow: true,
    },
    {
      label: "Covid % Change",
      pageUrl: helpCovidChangePageUrl,
      isShow: isCoralMediaSpecific ? false : true, // hiding for coralMediaOrg
    },
  ];

  // don't show for sellerUser and toohl/prooh
  if (isSellerUser || isToohlSpecific) {
    return null;
  }

  return (
    <>
      <li className="nav-item group-header">Methodologies</li>
      {sidebarMethodologiesConstants.map((info, i) => {
        const { isShow = true, pageUrl, label } = info;
        const activeClassName = activePageUrl === pageUrl && "active";

        if (!isShow) {
          return null;
        }

        return (
          <li key={i} className={`nav-item ${activeClassName}`}>
            <Link className="nav-link" to={constructRedirectPath(pageUrl)}>
              {label}
            </Link>
          </li>
        );
      })}
    </>
  );
}

function GeneralHelpSection({ activePageUrl, isToohlSpecific }) {
  // constants
  const sidebarGeneralConstants = [
    {
      label: "Definitions",
      pageUrl: helpDefinitionPageUrl,
      isShow: true,
    },
    {
      label: "Videos",
      pageUrl: helpVideosPageUrl,
      isShow: !isToohlSpecific,
    },
  ];

  return (
    <>
      <li className="nav-item group-header">General</li>
      {sidebarGeneralConstants.map((info, i) => {
        const { pageUrl, label, isShow = true } = info;
        const activeClassName = activePageUrl === pageUrl && "active";

        if (!isShow) {
          return null;
        }

        return (
          <li key={i} className={`nav-item ${activeClassName}`}>
            <Link className="nav-link" to={constructRedirectPath(pageUrl)}>
              {label}
            </Link>
          </li>
        );
      })}
    </>
  );
}

/**
 * Help Sidebar
 */
export default function HelpSidebar({ activePageUrl = "" }) {
  // Condition to check whether there is Toohl/prooh specific key in the url
  const isToohlSpecific = useUrlKeyCheck(UrlKeys.toohlSpecific);

  return (
    <aside className="sidebar bg-alt">
      <ul className="nav flex-column mt-3">
        <GeneralHelpSection
          activePageUrl={activePageUrl}
          isToohlSpecific={isToohlSpecific}
        />

        {/* methodologies */}
        <MethodologiesSection
          activePageUrl={activePageUrl}
          isToohlSpecific={isToohlSpecific}
        />
      </ul>
    </aside>
  );
}
